<template>
  <!--渲染表单-->
  <a-form-model ref="form" class="process-form" :label-col="{ span: 24 }" :rules="rules" :model="_value">
    <template v-for="(item, index) in _forms">
      <h3
        class="layout-title"
        v-if="oaComponentList.includes(item.name) && item.props && item.props.showName && hiddenComponents(item)"
        :key="`title_${item.id}_${index}`"><span>{{ item.title }}</span></h3>

      <!-- 分栏布局或控件组一些特殊组件 -->
      <form-design-render
        v-if="oaComponentList.includes(item.name) && hiddenComponents(item)"
        ref="span-layout"
        v-model="_value"
        mode="PC"
        :config="item"
        :formData="_value"
        :forms="_forms"
        :key="`special_${item.id}_${item.name}_${index}`"
      />
    </template>
  </a-form-model>
</template>

<script> 
 import FormDesignRender from '../../layout/form/FormDesignRender'
 export default {
  name: 'FormRender',
  components: { FormDesignRender },
  props: {
    forms: {
      type: Array,
      default: () => {
        return []
      }
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    actionType: { // init:初始化,audit:审核
      type: String,
      default: 'init'
    }
  },
  data() {
    return {
      rules: {},
      previousMeterType: null
      // 需要特殊校验的组件列表
     }
  },
  watch: {
    value: {
      handler(val) {
        // console.log('val', val)
        const bizAliasList = this._forms.filter(item => item.bizAlias)
        this._forms.forEach(item => {
          bizAliasList.forEach(bizAlias => {
            if (item.props.relatedDisplay && bizAlias.bizAlias == item.props.relatedField) {
              if ((val[bizAlias.id] + '').trim() === (item.props.relatedValue + '').trim()) {
                this.$set(item, 'isRelatedDisplay', false)
              } else {
                this.$set(item, 'isRelatedDisplay', true)
              }
            }
            if (item.props.relatedRequired && bizAlias.bizAlias == item.props.relatedField) {
              const oldRelatedRequired = item.isRelatedRequired
              if ((val[bizAlias.id] + '').trim() == (item.props.relatedValue + '').trim()) {
                this.$set(item, 'isRelatedRequired', true)
              } else {
                this.$set(item, 'isRelatedRequired', false)
              }
              // 当关联必填状态变化时，更新校验规则
              if (oldRelatedRequired !== item.isRelatedRequired) {
                this.updateFieldRule(item)
              }
            }
          })
        })
        const meterTypeItem = bizAliasList.find(v => v.bizAlias === 'meterType')
       },
      immediate: true,
      deep: true
    },
    forms: {
      handler(newForms) {
        this.loadFormConfig(newForms)
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    this.loadFormConfig(this.forms)
  },
  computed: {
      // OA控件组列表
      oaComponentList() {
            return [
                'SpanLayoutField',
                'OrderReviewForm',
                'ProjectInfoForm',
                'ProjectCostDataForm',
                'FirmwarePartNumberReferenceForm',
                'FirmwarePartNumberCreateForm',
                'MeterTypeForm',
                'MaterialForm',
                'ADMaterialGroupForm',
                'FirmwareInformationForm',
                'HardwareInformationForm',
                'SoftwareInformationForm',
                'StructuralInformationForm',
                'ProcessFileInformationForm',
                'DocumentInformationForm',
                'DocumentInformationNewForm',
                'SchemeChangeForm',
                'SaleInformationForm',
                'FunctionalTestingInformationForm'
                // 'ParseFirmwareVersionForm'
            ]
        },
    // 根据actionType及perm隐藏组件  actionType为init时，只隐藏perm为H的组件  actionType为audit时，隐藏perm为H和R的组件
    hiddenComponents() {
      return item => {
        if (this.actionType === 'init') {
          return item.perm !== 'H'
        } else {
          return !['H', 'R'].includes(item.perm)
        }
      }
    },
    _forms() {
      let result = []
      for (let i = 0; i < this.forms.length; i++) {
        if (['oaAssociation'].includes(this.forms[i].bizAlias)) {
          this.forms[i].isRelatedDisplay = true
        } else {
          if (this.forms[i] && this.forms[i].props && this.forms[i].props.relatedDisplay) {
            this.forms[i].isRelatedDisplay = true
          } else {
            this.forms[i].isRelatedDisplay = false
          }
        }
        // 初始化关联必填状态
        if (this.forms[i] && this.forms[i].props && this.forms[i].props.relatedRequired) {
          if (this.forms[i].isRelatedRequired === undefined) {
            this.forms[i].isRelatedRequired = false
          }
        }
        result.push(this.forms[i])
      };
      return result
    },
    _value: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {

    // 校验
    validate(call) {
      try {
        this.$refs.form.validate(valid => {
          if (!valid) {
            call && call(false)
            return
          }

          // 校验成功再校验内部组件
          this.validateSpecialComponents(0, call)
        })
      } catch (error) {
        console.error('FormRender validate error:', error)
        call && call(false)
      }
    },

    // 递归校验特殊组件（表格组件、文档资料组件等）
    validateSpecialComponents(index, callback) {
      try {
        // 如果所有组件都已校验完成
        if (index >= this.forms.length) {
          callback && callback(true)
          return
        }

        const formItem = this.forms[index]
        if (!formItem) {
          // 如果 formItem 不存在，继续下一个
          this.validateSpecialComponents(index + 1, callback)
          return
        }

        let needValidate = false

        // 校验表格组件
        if (formItem.name === 'TableField') {
          const formRef = this.$refs[`sub-item_${formItem.id}`]
          if (formRef && Array.isArray(formRef) && formRef.length > 0 && formRef[0].validate) {
            needValidate = true
            try {
              formRef[0].validate((subValid) => {
                if (subValid) {
                  // 继续校验下一个组件
                  this.validateSpecialComponents(index + 1, callback)
                } else {
                  callback && callback(false)
                }
              })
            } catch (error) {
              console.error(`TableField validate error for ${formItem.id}:`, error)
              // 出错时继续下一个组件
              this.validateSpecialComponents(index + 1, callback)
            }
          }
        }

        // 校验span-layout中的特殊组件（包括文档资料组件、分栏布局等）
        if (!needValidate && this.oaComponentList.includes(formItem.name)) {
          const spanLayoutRefs = this.$refs['span-layout']
          if (spanLayoutRefs) {
            const refsArray = Array.isArray(spanLayoutRefs) ? spanLayoutRefs : [spanLayoutRefs]
            let foundComponent = false

            for (let spanRef of refsArray) {
              // spanRef 是 FormDesignRender 实例，需要通过 config 来匹配
              if (spanRef && spanRef.$props && spanRef.$props.config) {
                const config = spanRef.$props.config
                // 匹配组件名称和ID，确保校验的是正确的组件实例
                if (config.name === formItem.name && config.id === formItem.id) {
                  foundComponent = true
                  // FormDesignRender 有 validate 方法，会调用内部实际组件的 validate
                  if (spanRef.validate && typeof spanRef.validate === 'function') {
                    needValidate = true
                    let callbackCalled = false
                    // 添加超时保护，防止回调永远不执行
                    const timeoutId = setTimeout(() => {
                      if (!callbackCalled) {
                        console.warn(`Component ${formItem.name} validate timeout for ${formItem.id}`)
                        callbackCalled = true
                        // 超时时继续下一个组件
                        this.validateSpecialComponents(index + 1, callback)
                      }
                    }, 5000) // 5秒超时

                    try {
                      spanRef.validate((subValid) => {
                        if (!callbackCalled) {
                          callbackCalled = true
                          clearTimeout(timeoutId)
                          if (subValid) {
                            // 继续校验下一个组件
                            this.validateSpecialComponents(index + 1, callback)
                          } else {
                            callback && callback(false)
                          }
                        }
                      })
                    } catch (error) {
                      if (!callbackCalled) {
                        callbackCalled = true
                        clearTimeout(timeoutId)
                        console.error(`Component ${formItem.name} validate error for ${formItem.id}:`, error)
                        // 出错时继续下一个组件
                        this.validateSpecialComponents(index + 1, callback)
                      }
                    }
                    break // 找到匹配的组件后跳出循环
                  } else {
                    // 如果组件存在但没有 validate 方法，继续下一个
                    break
                  }
                }
              }
            }

            // 如果找到了组件但不需要校验（比如没有 validate 方法），继续下一个
            if (foundComponent && !needValidate) {
              this.validateSpecialComponents(index + 1, callback)
              return
            }
          }
        }

        // 如果当前组件不需要校验，继续校验下一个
        if (!needValidate) {
          this.validateSpecialComponents(index + 1, callback)
        }
      } catch (error) {
        console.error('validateSpecialComponents error:', error)
        // 出错时返回 true，避免阻塞整个校验流程
        callback && callback(true)
      }
    },
    loadFormConfig(forms) {
      if (forms && forms.length) {
        forms.forEach(item => {
          if (this.oaComponentList.includes(item.name)) {
            // 递归处理分栏组件内的字段
            if (item.props && item.props.children && Array.isArray(item.props.children)) {
              this.loadFormConfig(item.props.children)
            }
          } else {
            this.$set(this._value, item.id, this.value[item.id])
            // 初始化时设置校验规则，考虑关联必填
            this.updateFieldRule(item)
          }
        })
      }
    },
    // 更新单个字段的校验规则
    updateFieldRule(item) {
      // 判断是否需要必填：静态必填 || (审核模式 && 编辑权限 && 条件必填) || 关联必填
      const needRequired = item.props.required ||
        (this.actionType === 'audit' && item.perm === 'E' && item.conditionRequired) ||
        item.isRelatedRequired

      if (needRequired) {
        // 设置必填规则
        const trigger = ['TextField', 'TextareaField', 'NumberField', 'MoneyField'].includes(item.name) ? 'blur' : 'change'
        this.$set(this.rules, item.id, [{
          trigger: trigger,
          required: true,
          message: `请${['TextField', 'TextareaField', 'NumberField', 'MoneyField'].includes(item.name) ? '填写' : '选择'}${item.title}`
        }])
      } else {
        // 如果之前有规则但现在不需要必填，移除规则
        if (this.rules[item.id]) {
          this.$set(this.rules, item.id, [])
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.process-form {
  margin-top: 12px;
  /deep/ .ant-form-item-label {
    line-height: 16px;
  }

  /deep/ .ant-form-item-control {
    line-height: 32px !important;
  }
}
</style>
